import { createLoader } from '@meteor/data-hooks';
import { withAuth } from '../../user';
import { billingClient } from '../client';

export let billingLoader = createLoader({
  name: 'billing',
  hash: i => i.organizationId,
  fetch: (i: { organizationId: string }) => withAuth(() => billingClient.subscription.get(i)),
  mutators: {
    updateSubscription: (
      i: {
        action:
          | {
              action: 'update_plan';
              planId: string;
              backUrl: string;
            }
          | {
              action: 'resume_subscription';
            }
          | {
              action: 'cancel_subscription';
            };
      },
      { input }
    ) => withAuth(() => billingClient.subscription.updateSubscription({ ...input, ...i })),

    updatePaymentMethod: async (i: void, { output }) => {
      let res = await withAuth(() =>
        billingClient.subscription.updatePaymentMethod({
          organizationId: output.subscription.organizationId,
          providerSubscriptionId: output.subscription.paymentSubscription?.id!
        })
      );

      let win = window.open(res.url, '_blank');
      if (win) win.focus();
    }
  }
});

export let useSubscription = (organizationId: string | null | undefined) => {
  let billing = billingLoader.use(organizationId ? { organizationId } : null);

  return {
    ...billing,
    updateSubscriptionMutator: billing.useMutator('updateSubscription'),
    updatePaymentMethodMutator: billing.useMutator('updatePaymentMethod')
  };
};

export let subscriptionsLoader = createLoader({
  name: 'subscriptions',
  hash: i => i.organizationId,
  fetch: (i: { organizationId: string }) =>
    withAuth(() => billingClient.subscription.listSubscriptions(i)),
  mutators: {}
});

export let useAllSubscriptions = (organizationId: string | null | undefined) => {
  return subscriptionsLoader.use(organizationId ? { organizationId } : null);
};

export let invoicesLoader = createLoader({
  name: 'invoices',
  hash: i => i.organizationId + i.providerSubscriptionId,
  fetch: (i: { organizationId: string; providerSubscriptionId: string }) =>
    withAuth(() => billingClient.subscription.listInvoices(i)),
  mutators: {
    downloadInvoice: async (i: { invoiceId: string }, { input }) => {
      let res = await withAuth(() =>
        billingClient.subscription.downloadInvoice({ ...input, ...i })
      );

      let a = document.createElement('a');
      a.href = res.url;
      a.setAttribute('rel', 'noopener noreferrer');
      a.target = '_blank';
      a.click();

      // location.href = res.url;
    }
  }
});

export let useInvoices = (
  organizationId: string | null | undefined,
  providerSubscriptionId: string
) => {
  let invoices = invoicesLoader.use(
    organizationId && providerSubscriptionId
      ? { organizationId, providerSubscriptionId }
      : null
  );

  return {
    ...invoices,
    downloadInvoiceMutator: invoices.useMutator('downloadInvoice')
  };
};
